import { render, staticRenderFns } from "./RootComponent.vue?vue&type=template&id=5f46e218&"
import script from "./RootComponent.vue?vue&type=script&lang=js&"
export * from "./RootComponent.vue?vue&type=script&lang=js&"
import style0 from "./RootComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports